import { createSelector } from 'reselect';
import { resolveProp } from '@clearscore/helpers.resolve-props';

const getRegistrationProspectId = (state) =>
    resolveProp('router.location.pathname', state).replace(new RegExp('/step.+/'), '');

export default createSelector(getRegistrationProspectId, (prospectId) => prospectId);
